// extracted by mini-css-extract-plugin
export var activeDot = "_3u-c";
export var buttonContainer = "_3u-9";
export var channelButton = "_3u-a";
export var clickable = "_3u-d";
export var content = "_3u-0";
export var contentFull = "_3u-2";
export var contentThird = "_3u-1";
export var contentWrapper = "_3u-7";
export var description = "_3u-5";
export var heightShort = "_3u-f";
export var image = "_3u-3";
export var imageContainer = "_3u-4";
export var selectButton = "_3u-e";
export var spinnerContainer = "_3u-b";
export var titleContent = "_3u-8";
export var titleWrapper = "_3u-6";